export class ResponseList{
    results: any= [];
    totalPages=0;
    totalResults=0;
}
export class ResponseDetail{
    data: any;
}
export class ErrorResponse{
    code=0;
    message='';
}
export class GetInputModel{
    limit = 10;
    page = 1;
    sortBy = "";
}